// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
// import SearchApt from './pages/SearchApt';
import Home from './pages/Home';
// import Diff from './pages/Diff';
// import Contact from './pages/Contact';
import ApartmentDetail from './pages/ApartmentDetail';
import Footer from './components/Footer';
import SignInUp from './components/SignInUp';
import MyInfo from './pages/MyInfo';
import Price from './pages/Price';
import AptMetrix from './pages/AptMetrix';
// import NL2SQL from './pages/NL2SQL';
import ApartmentSearch from './pages/ApartmentSearch';
import { useAppContext } from './context/AppContext';
// import GoogleLoginButton from './components/GoogleLoginButton';
import Success from './components/Success';
import Cancel from './components/Cancel';
import ProtectedRoute from './components/ProtectedRoute';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';


function App() {
  const { session, isLoading, error } = useAppContext();

  // loading, error 상태에 따른 처리 가능
  // if (isLoading) return <div>Loading...</div>;
  // if (error) return <div>Error: {error}</div>;

  return (
    <Router>
      <div className={`App`}>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/pilot" element={<Diff />} /> */}
          {/* <Route path="/apt" element={<SearchApt />} /> */}
          <Route path="/metrix" element={
            <ProtectedRoute element={<AptMetrix />} session={session} />
          } />
          {/* <Route path="/nl2sql" element={
            <ProtectedRoute element={<NL2SQL />} session={session} />
          } /> */}
          <Route path="/filter" element={
            <ProtectedRoute element={<ApartmentSearch />} session={session} />
          } />
          <Route path="/my" element={<MyInfo />} />
          <Route path="/price" element={<Price />} />
          {/* <Route path="/contact" element={<Contact />} /> */}
          <Route path="/apartment/:aptNo" element={
            <ProtectedRoute element={<ApartmentDetail />} session={session} />
          } />
          {/* <Route path="/apartment/:aptNo/:pyeongNo" element={<ApartmentDetail />} /> */} 
          <Route path="/sign" element={<SignInUp />} />
          <Route path="/success" element={session?.user ? <Success /> : <Home />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/tos" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          {/* 404 페이지 및 에러 처리를 위한 fallback 라우트 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <hr />
        <Footer />
      </div>
    </Router>
  )
}

export default App;
